import { useState, useEffect } from "react";
import { Divider, Grid, Tabs, Tab } from "@mui/material";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { useProductStore } from "../../../hooks/useProductStore";
import { useMediaQuery } from '@mui/material';
import '../../../assets/styles/facturacionv3-app.css';
import { CustomSearchProducts } from "./CustomSearchProducts";
import { ProductUsageAttributeAPI } from "../../../apis/ProductUsageAttributeAPI";
import { useProductUsageAttributeStore } from "../../../hooks/useProductUsageAttributeStore";

const columns = [
    { type: 'text', field: 'code_system', label: 'Código producto', align: 'center' },
    { type: 'text', field: 'name', label: 'Nombre', align: 'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align: 'center' },
    { type: 'text', field: 'cost', label: 'Costo', align: 'center' },
    { type: 'text', field: 'price', label: 'Precio', align: 'center' },
    { type: 'checkbox', field: 'checkbox', label: 'checkbox', align: 'center' },
];

export const SelectProductsModal: React.FC<any> = (props): JSX.Element | any => {
    const { open, closeModal, rowSelected, setFilter, clearState } = props;
    const { getProductsByCompany, getProducts } = useProductStore();
    const { createProductWithUsageAttribute} = useProductUsageAttributeStore()
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingdata, setLoadingdata] = useState<boolean>(false);
    const [products, setProducts] = useState<any>([]);
    const [temporarilySelected, setTemporarilySelected] = useState<any>([]);
    const [persistedSelected, setPersistedSelected] = useState<any>([]);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);
    const [tabIndex, setTabIndex] = useState(0);

    const isSxSmMd = useMediaQuery('(min-width: 900px) and (max-width: 1536px)');

    useEffect(() => {
        getProductsApi();
    }, []);

    const getProductsApi = async (search = '', idcategory = '', idsubcategory = '', idspecificsubcategory = '') => {
        try {
            setLoadingdata(true);
            const response = await getProducts({ search, idcategory, idsubcategory, idspecificsubcategory });

            const selected:any = [];
            const available:any = [];
            response && response.length > 0 && response.forEach((item) => {
                const product:any = {
                    id: item.id,
                    code: item.code,
                    code_system: item.code_system,
                    code_erp: item.code_erp,
                    barcode: item.barcode,
                    name: item.name,
                    description: item.description,
                    cointypesymbol: item.cointypesymbol,
                    cost: item.cost,
                    price: item.price,
                    offerprice: item.offerprice,
                    stock: 0,
                    discount: 0,
                    subtotal: 0,
                    idcompany: item.idcompany,
                };

                if (item.iduses && item.iduses.includes(rowSelected.id)) {
                    selected.push(product);
                } else {
                    available.push(product);
                }
            });
            setPersistedSelected(selected);
            setProducts(available);
            setLoadingdata(false);
        } catch (error) {
            setLoadingdata(false);
        }
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            setTemporarilySelected(products.map((n) => n));
        } else {
            setTemporarilySelected([]);
        }
    };

    const onCheckbox = (row) => {
        const selectedIndex = temporarilySelected.findIndex(selectedRow => selectedRow.id === row.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(temporarilySelected, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(temporarilySelected.slice(1));
        } else if (selectedIndex === temporarilySelected.length - 1) {
            newSelected = newSelected.concat(temporarilySelected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                temporarilySelected.slice(0, selectedIndex),
                temporarilySelected.slice(selectedIndex + 1),
            );
        }
        setTemporarilySelected(newSelected);
    };

    const isSelected = (row) => {
        return temporarilySelected.some(item => item.id === row.id);
    };

    const onSearch = (term) => {
        clearTimeout(searchTimeout);
        setSearchTimeout(
            setTimeout(() => { getProductsApi(term) }, 1000)
        );
    };

    const onSubmit = async () => {
        await createProductWithUsageAttribute(rowSelected?.id, { products: temporarilySelected })
        setTabIndex(0);
        await getProductsApi()
    };

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    return (
        <>
            <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="lg" paperprops={{ style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' } }}>
                <ModalHeader
                    text={'Seleccionar productos'}
                    className='positionElements'
                    onCancel={closeModal}
                    clearState={clearState}
                />
                <ModalBody>

                    <Tabs value={tabIndex} onChange={handleTabChange} aria-label="product selection tabs">
                        <Tab label="Seleccionados" />
                        <Tab label="Disponibles" />
                    </Tabs>

                    {tabIndex === 0 && (
                        <Grid container sx={{ padding: '0px 20px 20px 20px' }}>
                            <Grid item container xs={12} spacing={2}>
                                <Grid item xs={12}>
                                    <CustomTable
                                        disabled_title
                                        columns={columns}
                                        loading={loadingdata}
                                        rows={persistedSelected || []}
                                        onRowClick={() => { }}
                                        RowsPerPage={5}
                                        heightTable={420}
                                        dense
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    )}

                    {tabIndex === 1 && (
                        <>
                            <CustomSearchProducts setProducts={setProducts} getProductsApi={getProductsApi} />
                            <Grid container sx={{ padding: '0px 20px 20px 20px' }}>
                                <Grid item container xs={12} spacing={2}>
                                    <Grid item xs={12}>
                                        <CustomTable
                                            disabled_title
                                            columns={columns}
                                            loading={loadingdata}
                                            rows={products || []}
                                            onRowClick={() => { }}
                                            selectAll={handleSelectAllClick}
                                            onCheckbox={onCheckbox}
                                            isSelected={isSelected}
                                            onSearch={onSearch}
                                            RowsPerPage={5}
                                            heightTable={420}
                                            dense
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Divider />
                            <ModalFooter
                                buttonType="submit"
                                confirmText={'Agregar productos'}
                                onConfirm={onSubmit}
                                loadingConfirmText={loading}
                                clearState={clearState}
                            />
                        </>
                    )}
                </ModalBody>
            </Modal>
        </>
    );
};
